export const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://kjfphsq4hw.ap-south-1.awsapprunner.com',
  uploadUrl: process.env.REACT_APP_UPLOAD_URL || 'https://pingvite-media-dev.s3.ap-south-1.amazonaws.com',
  turnstileSiteKey: process.env.REACT_APP_TURNSTILE_SITE_KEY || '',
};
